import React from "react";
import styled from "styled-components";

import Layout from "@components/Layout";

import { Container } from "@styles/grid";

import ChecklistAddForm from "./ChecklistAddForm";

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 3rem 5.5rem 5.5rem;
`;

const ChecklistsAdd = () => {
  return (
    <Layout pageTitle="Add Checklist">
      <Container>
        <Content>
          <ChecklistAddForm />
        </Content>
      </Container>
    </Layout>
  );
};

export default ChecklistsAdd;
